import getDatabase from '../api/getDatabaseHeaders'

export default eventType => (dispatch, state) => {
    
    getDatabase(eventType)
    .then(response => {
            dispatch({ type: 'GET_DATABASE', headers: response.headers, database: response})
        })
        .catch(err => {
            console.error(err)
        })
}
